import React from "react";
import { Container, Row, Col } from "react-bootstrap";


import "../styles/Dashboard.css";

import TableComponent from "../components/TableComponent/TableComponent";


const Others = () => {
  const tableTitle = "Others";

  const columns = ["Name", "Email", "Mobile", "CNIC"];
  const data = [
    {
      Name: "Alice",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Approved: true,
    },
    {
      Name: "Bob",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Approved: false,
    },
    {
      Name: "Charlie",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Approved: true,
    },
    {
      Name: "Diana",
      Email: "user@gmail.com",
      Mobile: "+923009090909",
      CNIC: "3100-30303030-7",
      Approved: false,
    },
  ];

  const handleEdit = (row) => {
    // Implement edit logic here (open a modal, navigate to edit page, etc.)
  };

  const handleDelete = (row) => {
    // Implement delete logic here (e.g., show a confirmation dialog, remove from state, etc.)
  };

  const handleDownload = (row) => {
    // Implement download logic here (e.g., download file or export row data)
  };

  // Pass dynamically if these features should be shown
  const showSearchBar = false; // Change to false to hide search bar
  const showFilter = false; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;
  const showCount = true;

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={columns}
            data={data}
            title={tableTitle}
            showSearchBar={showSearchBar}
            showFilter={showFilter}
            showTabs={showTabs}
            showColors={showColors}
            showCount={showCount}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onDownload={handleDownload}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Others;
